import React from 'react';
import { Outlet } from 'react-router-dom';
import TopBar from '../../hooks/TopBar';
import SideBar from '../../hooks/SideBar';
import { faUser, faCalendarAlt, faHistory, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const navItems = [
  { label: 'User Control', path: '/admin/user-control', icon: <FontAwesomeIcon icon={faUser} /> },
  { label: 'Event History', path: '/admin/event-history', icon: <FontAwesomeIcon icon={faCalendarAlt} /> },
  { label: 'Match History', path: '/admin/match-history', icon: <FontAwesomeIcon icon={faHistory} /> },
  { label: 'Match Report', path: '/admin/match-report', icon: <FontAwesomeIcon icon={faFileAlt} /> },
];

const ALayout = () => {
  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: "linear-gradient(180deg, rgba(212,69,27,0) 0%, #D4451B 100%), #FF9B45",
      color: "#F9F2DF"
    }}>
      <TopBar />
      <div style={{ display: 'flex', height: '100vh' }}>
        <SideBar navItems={navItems} />
        <div style={{ flex: 1, overflowY: 'auto' }}>
          <Outlet />  {/* EventHistory, MatchHistory, etc */}
        </div>
      </div>

    </div>
  );
};

export default ALayout;
